import { z, type ZodType } from '@customerio/hydra-validation';
import type { Newsletter as ApiNewsletter } from '@customerio/hydra-ui-api';
import { defineEntity } from '../shared/define-entity';

/**
 * Newsletter (broadcast) entity — workspace-scoped.
 *
 * Minimal detail-only entity. The wire already encodes `id` as a string, so
 * no normalization is needed; the read schema is a passthrough today. Date
 * transforms / a list+mutation surface can be added when a consumer needs
 * them.
 */
export type Newsletter = ApiNewsletter;

// oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
const NewsletterFromApi = z.looseObject({}) as unknown as ZodType<Newsletter, unknown>;

/** @public */
export const newsletter = defineEntity<Newsletter>({
  name: 'newsletter',
  scope: 'workspace',
  pk: (n) => n.id,
  schema: { read: NewsletterFromApi },
});

export const newsletterKeys = newsletter.keys;

export function parseNewsletter(raw: ApiNewsletter): Newsletter {
  return newsletter.parse(raw);
}
